export default {
  NATURAL: 'natural',
  LEGAL: 'legal',
};